import type { RawDraftEntity } from 'draft-js';
import { DraftConverter, MapEntityToMarkFn, MarkType } from '@tiptap/draftjs-to-tiptap';

// Add custom function to handle exception mention type when copying and pasting link
/* data format:
{
  "type": "LINK",
  "mutability": "MUTABLE",
  "data": {
    "url": "https://www.ahajournals.org/doi/10.1161/cir.0000000000000625#core-R95",
    "href": "https://www.ahajournals.org/doi/10.1161/cir.0000000000000625#core-R95"
  }
}
*/

const entityToMarkMapping: Record<
  string,
  (context: { entity: RawDraftEntity; converter: DraftConverter }) => MarkType | null
> = {};

export const mapAvoEntityToMark: MapEntityToMarkFn = function ({
  range: { key },
  entityMap,
  converter,
}) {
  if (entityToMarkMapping[entityMap[key].type]) {
    return entityToMarkMapping[entityMap[key].type]({
      entity: entityMap[key],
      converter,
    });
  }

  return null;
};
